import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ScrollToTop } from './utils/helpers';

const tagManagerArgs = {
  gtmId: window.envConfig.GOOGLE_TAG_MANAGER_ID,
  auth: window.envConfig.GOOGLE_TAG_MANAGER_AUTH,
  preview: window.envConfig.GOOGLE_TAG_MANAGER_ENV,
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(null);
